import React from "react";
import Radium from "radium";
import update from "immutability-helper";
import PropTypes from "prop-types";
import StylePropType from "react-style-proptype";
import Styles from "./SortableList.styles";
import DraggableListItem from "../../components/DraggableListItem";

class SortableList extends React.Component {
  constructor(props) {
    super();
    this.state = {
      items: props.items || [],
      selectedItemId: props.selected,
      disabledItems: props.disabledItems
    };

    this.moveItem = this.moveItem.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const updates = {
      items: newProps.items,
      disabledItems: newProps.disabledItems,
      selectedItemId: newProps.selected
    };
    this.setState(updates);
  }

  onItemClick(props) {
    const isDisabled = this.state.disabledItems.includes(props.id);
    if (!isDisabled) {
      this.setState({ selectedItemId: props.id }, () => {
        this.props.onItemClick(props);
      });
    }
  }

  moveItem(dragIndex, hoverIndex) {
    const { items } = this.state;
    const dragItem = items[dragIndex];

    this.setState(
      update(this.state, {
        items: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragItem]]
        }
      })
    );
  }

  renderListItem(item, index) {
    const isDisabled = this.state.disabledItems.includes(item.id);
    const disabledStyle = isDisabled ? { color: "#aaa" } : {};
    return (
      <DraggableListItem
        icon={item.icon}
        secondaryIcon={item.secondaryIcon}
        key={item.id}
        index={index}
        id={item.id}
        moveItem={this.moveItem}
        text={item.text}
        onClick={this.onItemClick}
        selected={this.state.selectedItemId === item.id}
        style={{ ...this.props.itemStyle, ...item.style, ...disabledStyle }}
        canDrag={!isDisabled}
      />
    );
  }

  render() {
    const { items } = this.state;
    const { style, horizontal } = this.props;
    return (
      <div
        style={[
          Styles.wrapper,
          horizontal ? Styles.wrapperHorizontal : {},
          style
        ]}
      >
        {items.map((item, i) => item && this.renderListItem(item, i))}
      </div>
    );
  }
}

SortableList.propTypes = {
  style: StylePropType,
  horizontal: PropTypes.bool,
  selected: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array
  ]),
  disabledItems: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array
  ]),
  onItemClick: PropTypes.func,
  itemStyle(props, propName, componentName) {
    const currentProp = props[propName];
    const currentPropKeys = Object.keys(currentProp);

    const newProps = {
      ...props,
      [propName]: currentPropKeys.reduce((acc, curr) => {
        if ([":hover", "selected"].includes(curr)) {
          return acc;
        }

        acc[curr] = currentProp[curr];

        return acc;
      }, {})
    };

    return StylePropType(newProps, propName, componentName);
  }
};

SortableList.defaultProps = {
  style: {},
  horizontal: false,
  selected: null,
  onItemClick: () => {},
  itemStyle: {},
  disabledItems: []
};

// <Card key={item.id} index={i} id={card.id} text={card.text} moveCard={this.moveCard} />

export default Radium(SortableList);



// WEBPACK FOOTER //
// ./src/components/SortableList/SortableList.js